import styled from 'styled-components';
import { formControlBase, formControlBaseSelect, formControlTheme, formControlErrorTheme } from "../../styles";

var selectTheme = function selectTheme(props) {
  return props.theme.formSelect === 'dark' ? 'dark' : 'light';
};

export default styled.select.withConfig({
  displayName: "Select",
  componentId: "sc-1197ti8-0"
})(["", ";", ";", ";", ";"], formControlBase(), formControlBaseSelect(), function (props) {
  return formControlTheme(selectTheme(props));
}, function (props) {
  return props.error && formControlErrorTheme(selectTheme(props));
});